function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import NukaCarousel from '@domain-group/fe-allhomes-nuka-carousel';
import LazyLoadedContainer from '@domain-group/fe-co-allhomes-lazy-loaded-container';
import Item from '../../models/item';
import CarouselItem from '../carousel-item/carousel-item';
import euclideanModulus from '../../utils/euclidean-modulus';
import layout from '../../models/layout';
import * as styles from './carousel.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var LAZY_LOAD_PADDING = 1;

// Enclose a set of React elements inside lazy-loaded containers so that they can be displayed when requested.
/* eslint-disable no-param-reassign, react/no-array-index-key */
function enclose(items, refs) {
  return items.map((item, index) => ___EmotionJSX(LazyLoadedContainer, {
    css: styles.lazyLoad,
    key: index,
    ref: _ref => {
      refs[index] = _ref;
    }
  }, item));
}
/* eslint-enable no-param-reassign, react/no-array-index-key */

class Carousel extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "lazyLoad", () => {
      var total = this.props.items.length;
      for (var index = -LAZY_LOAD_PADDING; index <= LAZY_LOAD_PADDING; index += 1) {
        var _this$itemRefs$euclid;
        (_this$itemRefs$euclid = this.itemRefs[euclideanModulus(this.currentIndex + index, total)]) === null || _this$itemRefs$euclid === void 0 ? void 0 : _this$itemRefs$euclid.load();
      }
    });
    _defineProperty(this, "next", () => {
      if (this.slider) {
        this.slider.nextSlide();
      }
    });
    _defineProperty(this, "previous", () => {
      if (this.slider) {
        this.slider.previousSlide();
      }
    });
    _defineProperty(this, "slideTo", idx => {
      if (this.slider) {
        // Avoid the jump back when wrapping.
        if (this.currentIndex === 0 && idx === this.props.items.length - 1) {
          this.previous();
        } else if (this.currentIndex === this.props.items.length - 1 && idx === 0) {
          this.next();
        } else {
          this.slider.goToSlide(idx);
        }
      }
    });
    _defineProperty(this, "handleItemClick", (index, item) => {
      this.setState({
        showOverlay: false
      });
      this.props.onClick(index, item);
    });
    _defineProperty(this, "handleBeforeSlide", (currentSlide, nextSlide) => {
      this.slidingTo = nextSlide;
      this.setState({
        showOverlay: true
      });
      this.currentIndex = nextSlide;
      this.lazyLoad();
      if (currentSlide !== nextSlide) {
        this.props.onChange(nextSlide, currentSlide);
      }
    });
    this.state = {
      showOverlay: true
    };
    this.currentIndex = this.props.selectedIndex;
    this.slidingTo = null;
    this.itemRefs = [];
  }
  componentDidMount() {
    this.lazyLoad();
  }
  // Ignore selectedIndex prop when deciding whether to rerender the component
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.items !== this.props.items) {
      return true;
    }
    if (nextState.showOverlay !== this.state.showOverlay) {
      return true;
    }
    if (nextProps.layout !== this.props.layout) {
      return true;
    }
    if (nextProps.selectedIndex !== this.props.selectedIndex) {
      if (nextProps.selectedIndex !== this.slidingTo) {
        this.slideTo(nextProps.selectedIndex);
      }
      this.slidingTo = null;
      return false;
    }
    return false;
  }
  render() {
    var needCarousel = this.props.items.length > 1;
    var everything = this.props.items.map((item, index) => ___EmotionJSX(CarouselItem, {
      layout: this.props.layout,
      key: item.src,
      onClick: () => this.handleItemClick(index, item),
      showOverlay: this.state.showOverlay,
      item: item
    }));
    var carouselItems = enclose(everything, this.itemRefs);
    return ___EmotionJSX("div", {
      css: styles.carousel
    }, needCarousel ? ___EmotionJSX(NukaCarousel, {
      ref: slider => {
        this.slider = slider;
      },
      decorators: [],
      wrapAround: true,
      slideIndex: this.props.selectedIndex,
      beforeSlide: this.handleBeforeSlide,
      easing: "easeOutSine"
    }, carouselItems) : ___EmotionJSX("div", null, carouselItems));
  }
}
Carousel.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(Item)),
  selectedIndex: PropTypes.number,
  layout: PropTypes.shape(layout),
  onChange: PropTypes.func,
  onClick: PropTypes.func
};
Carousel.defaultProps = {
  items: [],
  selectedIndex: 0,
  layout: {},
  onChange: () => {},
  onClick: () => {}
};
export default Carousel;